var React = require('react');

function ErrorInline (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"8","cy":"8","r":"6","fill":"#FFF","key":0}),React.createElement("path",{"d":"M8 0C3.6 0 0 3.6 0 8s3.6 8 8 8 8-3.6 8-8-3.6-8-8-8zm3.5 10.1-1.4 1.4L8 9.4l-2.1 2.1-1.4-1.4L6.6 8 4.5 5.9l1.4-1.4L8 6.6l2.1-2.1 1.4 1.4L9.4 8l2.1 2.1z","fill":"#CD1D2C","key":1})]);
}

ErrorInline.defaultProps = {"viewBox":"0 0 16 16","fill":"none"};

module.exports = ErrorInline;

ErrorInline.default = ErrorInline;
